<template>
  <!-- 弹框 -->
  <vh-dialog
    :title="$t('host.k_578001')"
    :visible.sync="dialogProductList"
    :close-on-click-modal="false"
    class="products-dialog"
    width="600px"
    :modal="false"
  >
    <vh-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      max-height="500"
      :header-cell-style="{ background: '#f7f7f7', color: '#666', height: '56px' }"
    >
      <vh-table-column :label="$t('host.k_578002')">
        <template slot-scope="scope">
          <div class="flexBox">
            <div class="gift-cover">
              <img :src="scope.row.cover_img" alt="" />
            </div>
          </div>
        </template>
      </vh-table-column>
      <vh-table-column
        :label="$t('host.k_578003')"
        prop="name"
        show-overflow-tooltip
      ></vh-table-column>
      <vh-table-column :label="$t('host.k_578004')" prop="price" width="100"></vh-table-column>
      <vh-table-column
        :label="$t('host.k_578005')"
        prop="discount_price"
        width="100"
      ></vh-table-column>
    </vh-table>
  </vh-dialog>
</template>

<script>
  import { useLotteryServer } from 'middle-domain';
  export default {
    name: 'CouponGoodsList',
    props: {
      couponId: {
        type: [String, Number],
        default: ''
      }
    },
    data() {
      return {
        tableData: [], // 列表数据
        total: 0, // 列表总数
        dialogProductList: false
      };
    },
    components: {},
    methods: {
      async getList() {
        const params = {
          coupon_id: this.couponId
        };

        let res = await this.lotteryServer.getListCouponGoods(params);
        if (res.code == 200 && res.data) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      },

      async open() {
        // console.log(this.couponId);
        await this.getList();
        this.dialogProductList = true;
      }
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
    }
  };
</script>

<style lang="less" scoped>
  .products-dialog {
    .flexBox {
      display: flex;
      align-items: center;
      .name {
        margin-left: 10px;
      }
      .gift-cover {
        display: inline-block;
        width: 70px;
        min-width: 70px;
        height: 70px;
        // margin: 3px 0;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e6e6e6;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }
    }
  }
</style>
